export default __webpack_public_path__ + "static/media/python.00b3dfd2.svg";